import {StyleSheet, Dimensions} from 'react-native';
const {width} = Dimensions.get('window');
const imageWidth = width * 0.32;

// Theme-aware styles factory (the makeStyles pattern — docs/DARK-MODE.md):
// consumed via useThemedStyles(makeStyles) so colors re-resolve on theme
// change instead of baking at module load.
const makeStyles = colors =>
  StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: colors.backgroundMuted,
    },
    headerView: {
      marginHorizontal: 24,
    },
    contentContainer: {
      flex: 1,
    },
    titleContainer: {
      paddingHorizontal: 24,
      backgroundColor: colors.backgroundMuted,
      alignItems: 'center',
      marginTop: 24,
    },
    typeContainer: {
      flex: 1,
      marginTop: 32,
      paddingHorizontal: 24,
      backgroundColor: colors.surface,
      borderTopLeftRadius: 24,
      borderTopRightRadius: 24,
      paddingTop: 32,
    },
    userProfileImage: {
      width: imageWidth,
      height: imageWidth,
      borderRadius: 24,
      borderWidth: 2,
      borderColor: colors.backgroundMuted,
      shadowColor: colors.shadow,
      shadowRadius: 30,
      shadowOpacity: 0.2,
      shadowOffset: {height: 30, width: 0},
      marginTop: 24,
    },
    buttonsContainer: {
      marginHorizontal: 24,
      marginTop: 24,
    },
    rightButton: {
      marginLeft: 16,
      flex: 1,
      backgroundColor: colors.danger,
    },
    whiteBackgroundView: {
      position: 'absolute',
      right: 0,
      left: 0,
      bottom: 0,
      height: '30%',
      backgroundColor: colors.surface,
    },
    deleteButton: {
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: 8,
    },
    fullScreenHeight: {
      height: '100vh',
    },
    wrapper: {
      width: '30%',
      alignSelf: 'flex-end',
    },
  });

export default makeStyles;
